import CollectionsCatalog from '../components/CollectionsCatalog';
import Banner from '../components/Banner';

function Collections() {
  return (
    <div className='App'>
      <Banner/>
      <CollectionsCatalog/>
    </div>    
  );
}

export default Collections;
